import React from 'react';
import {TableCell, withStyles} from '@material-ui/core';

export const StyledTableCell = withStyles(theme => ({
  head: {
    background: theme.palette.graphColors.themeDarkGray,
    borderBottom: `1px solid ${theme.palette.graphColors.themeDarkGray}`,
    fontWeight: 'bold',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    padding: 8,
    cursor: 'pointer',
  },
  root: {
    paddingTop: 8,
    paddingBottom: 8,
    '&.metricCell': {
      paddingLeft: 52,
      paddingRight: 52,
    },
    '&.metricHeaderCell': {
      paddingLeft: 44,
      paddingRight: 44,
    },
    '&.splitLabelCell': {
      paddingLeft: 32,
      paddingRight: 32,
    },
  },
  body: {
    cursor: 'pointer',
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.graphColors.themeDarkGray}`,
  },
}))(TableCell);
